import { safeLazy } from "utils/safeLazy"

// === Service Pages ===
export const LoginPage = safeLazy(() => import("./login"))
export const PageNotFoundPage = safeLazy(() => import("./404"))
export const UnderMaintenancePage = safeLazy(() => import("./underMaintenance"))
export const AppOldVersionPage = safeLazy(() => import("./appOldVersion"))
export const JailPage = safeLazy(() => import("./jail"))
export const AmlPage = safeLazy(() => import("./aml"))
export const PrivacyPolicyPage = safeLazy(() => import("./privacy-policy"))
export const TermsOfUsePage = safeLazy(() => import("./terms-of-use"))
export const TestDogLottiePage = safeLazy(() => import("./test-dog-lottie"))
export const TestLottieApparelsPage = safeLazy(
  () => import("./test-lottie-apparels")
)

// === Common Pages ===
export const HomePage = safeLazy(() => import("./home"))

// === Mine Pages ===
export const MineEntrancePage = safeLazy(() => import("./mine/entrance"))
export const MineGamePage = safeLazy(() => import("./mine/game"))

// === Wallet Pages ===
export const WalletWrapperPage = safeLazy(() => import("./wallet"))
export const BuyGoldPage = safeLazy(() => import("./wallet/pages/buyGold"))
export const DepositPage = safeLazy(() => import("./wallet/pages/deposit"))
export const WithdrawalPage = safeLazy(
  () => import("./wallet/pages/withdrawal")
)
export const BalanceHistoryPage = safeLazy(
  () => import("./wallet/pages/balance-history")
)
export const StakingPage = safeLazy(() => import("./wallet/pages/staking"))
export const StakingActivePlansPage = safeLazy(
  () => import("./wallet/pages/staking-active-plans")
)
export const CompleteStakingPage = safeLazy(() => import("./completeStaking"))
export const InitWithdrawalPage = safeLazy(() => import("./initWithdrawal"))
export const ReferralsWrapperPage = safeLazy(() => import("./referrals"))
export const ReferralDetailsPage = safeLazy(
  () => import("./referrals/pages/details")
)
export const ReferralCommissionsPage = safeLazy(
  () => import("./referrals/pages/commissions")
)
export const ReferralFriendsPage = safeLazy(
  () => import("./referrals/pages/friends")
)
export const PurchaseStatusPage = safeLazy(
  () => import("./wallet/pages/buyGold/ui/purchaseStatus")
)

// === Expeditions Pages ===
export const ExpeditionsPage = safeLazy(() => import("./expeditions"))

// === Leaderboard Pages ===
export const LeaderboardPage = safeLazy(() => import("./leaderboard"))
export const LeaderboardPersonalPage = safeLazy(
  () => import("./leaderboard/pages/perosnal")
)

// === Hero Pages ===
export const HeroWrapperPage = safeLazy(() => import("./hero"))
export const TrainingPage = safeLazy(() => import("./hero/pages/training"))
export const ProfessionsPage = safeLazy(
  () => import("./hero/pages/professions")
)
export const AchievementsPage = safeLazy(
  () => import("./hero/pages/achievements")
)

// === Store Pages ===
export const StoreWrapperPage = safeLazy(() => import("./store"))
export const AuctionPage = safeLazy(() => import("./store/pages/auction"))
export const AuctionHistoryPage = safeLazy(
  () => import("./store/pages/auction-history")
)
export const StoreOffersPage = safeLazy(
  () => import("./store/pages/store-offers")
)
export const StoreTonPage = safeLazy(() => import("./store/pages/store-ton"))
export const TonShopWrapperPage = safeLazy(
  () => import("./store/pages/ton-shop-wrapper")
)
export const StorePage = safeLazy(() => import("./store/pages/store"))

// === Inventory Pages ===
export const InventoryWrapperPage = safeLazy(() => import("./inventory"))
export const CraftPage = safeLazy(() => import("./inventory/pages/craft"))
export const InventoryPage = safeLazy(
  () => import("./inventory/pages/inventory")
)

// === Quests Pages ===
export const QuestsWrapperPage = safeLazy(() => import("./quests"))
export const QuestsDailyRewardsPage = safeLazy(
  () => import("./quests/pages/daily/daily-content")
)
export const QuestsGuidePage = safeLazy(
  () => import("./quests/pages/guide/guide-content")
)
export const QuestsListPage = safeLazy(
  () => import("./quests/pages/quests/quests-list")
)
export const QuestsMissionsPage = safeLazy(
  () => import("./quests/pages/missions/missions-content")
)
export const PointsLeaderboardPage = safeLazy(
  () => import("./quests/pages/missions/points-leaderboard")
)

// === Clans Pages ===
export const ClanMapPage = safeLazy(() => import("./clans/map"))
export const ClanBankPage = safeLazy(() => import("./clans/clan-bank"))
export const ClansPage = safeLazy(() => import("./clans/clans-page"))
export const ClanLeaderboardsPage = safeLazy(
  () => import("./clans/clan-leaderboards")
)
export const ClanForm = safeLazy(() => import("./clans/clan-form"))
export const ExamineClanPage = safeLazy(
  () => import("./clans/examine-clan-page")
)
export const ClansLayoutPage = safeLazy(() => import("./clans/clans-layout"))
export const ClanHutPagePage = safeLazy(() => import("./clans/clan-hut-page"))
export const ClanChatPage = safeLazy(() => import("./clans/clan-chat"))
export const ClansHomePage = safeLazy(() => import("./clans"))
export const AltarWrapperPage = safeLazy(() => import("./clans/altar"))
export const AltarPage = safeLazy(() => import("./clans/altar/pages/altar"))
export const AltarActivityLogsPage = safeLazy(
  () => import("./clans/altar/pages/altar-activity-logs")
)

// === Boss Pages ===
export const BossLayout = safeLazy(() => import("./boss/layout"))
export const BossPage = safeLazy(() => import("./boss"))
export const DarkHeroPage = safeLazy(() => import("./boss/hero"))
export const BossRoomPage = safeLazy(() => import("./boss/room"))
export const BossArenaPage = safeLazy(() => import("./boss/arena"))
export const BossArenaAttackPage = safeLazy(() => import("./boss/arena/attack"))
export const BossLeaderboardPage = safeLazy(() => import("./boss/leaderboard"))

// === Sale Chest Pages ===
export const SaleChestPage = safeLazy(() => import("./sale-chest"))
